import { render, staticRenderFns } from "./Announcement1.vue?vue&type=template&id=3c2a99e2&scoped=true"
import script from "./Announcement1.vue?vue&type=script&lang=js"
export * from "./Announcement1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2a99e2",
  null
  
)

export default component.exports